<!-- Start Header Top
============================================= -->
<div class="top-bar-area top-bar-style-one bg-dark text-light">
  <div class="container">
    <div class="row align-center">
      <div class="col-xl-7 col-lg-8 offset-xl-3 pl-30 pl-md-15 pl-xs-15">
        <ul class="item-flex">
          <li>
            <i class="fas fa-map-marker-alt"></i> 5-8-670, Srinivasa Nagar, Vijayawada
          </li>
          <li>
            <a href="tel:+919281441225"><i class="fas fa-phone-alt"></i> +91 92814 41225</a>
          </li>
          <li>
            <a href="mailto:info@novarix.tech"><i class="fas fa-envelope"></i> info@novarix.tech</a>
          </li>
        </ul>
      </div>
      <div class="col-xl-2 col-lg-4 text-end">
        <div class="social">
          <ul>
            <li>
              <a href="#">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="fab fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@novarixtech" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/novarix-tech-labs/" target="_blank">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Header Top -->
<!-- Header
============================================= -->
<header>
  <!-- Start Navigation -->
  <nav class="navbar mobile-sidenav navbar-style-one navbar-sticky navbar-default validnavs white navbar-fixed no-background">

    <div class="container">
      <div class="row align-center flex-nowrap">

        <!-- Start Header Navigation -->
        <div class="col-xl-auto col-lg-auto col-md-3 col-sm-6 col-6 flex-shrink-0">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
              <i class="fa fa-bars"></i>
            </button>
            <a class="navbar-brand" routerLink="/">
              <img src="assets/img/novarix.png" class="logo" alt="Logo">
            </a>
          </div>
        </div>
        <!-- End Header Navigation -->
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="col-xl-auto col-lg-auto col-md-1 col-sm-1 col-1 ms-auto d-flex justify-content-end flex-shrink-0">
          <div class="collapse navbar-collapse justify-content-end" id="navbar-menu">

            <img src="assets/img/novarix.png" alt="Logo">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
              <i class="fa fa-times"></i>
            </button>

            <ul class="nav navbar-nav navbar-right" data-in="fadeInDown" data-out="fadeOutUp">
              <li>
                <a routerLink="/"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{exact: true}">Home</a>
              </li>
              <li class="dropdown">
                <a class="dropdown-toggle" href="javascript:void(0)" tabindex="0" data-toggle="dropdown" style="cursor: pointer;">Products</a>
                <ul class="dropdown-menu">
                  <li><a href="https://norbix.novarix.tech" target="_blank">Norbix Enterprise <span class="badge bg-primary ms-1" style="font-size: 10px; vertical-align: middle;">Suite</span></a></li>
                  <li><a href="https://norbix.novarix.tech/products/novahrm" target="_blank">NovaHRM</a></li>
                  <li><a href="https://norbix.novarix.tech/products/novafleet" target="_blank">NovaFLEET</a></li>
                  <li><a href="https://norbix.novarix.tech/products/novaconnects" target="_blank">NovaConnects</a></li>
                  <li><a href="https://compass.novarix.tech" target="_blank">Norbix Compass</a></li>
                </ul>
              </li>
              <li>
                <a routerLink="/services"
                   routerLinkActive="active">Services</a>
              </li>
              <li>
                <a routerLink="/portfolio"
                   routerLinkActive="active">Portfolio</a>
              </li>
              <li class="dropdown" routerLinkActive="active">
                <a class="dropdown-toggle" href="javascript:void(0)" tabindex="0" data-toggle="dropdown" style="cursor: pointer;">Company</a>
                <ul class="dropdown-menu">
                  <li><a routerLink="/about-us" routerLinkActive="active">About Us</a></li>
                  <li><a routerLink="/organizational-chart" routerLinkActive="active">Organizational Chart</a></li>
                  <li><a routerLink="/mentor" routerLinkActive="active">Mentors & Advisory</a></li>
                </ul>
              </li>
              <li>
                <a routerLink="/contact"
                   routerLinkActive="active">Contact</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /.navbar-collapse -->

        <div class="col-xl-auto col-lg-auto col-md-8 col-sm-5 col-5 text-end flex-shrink-0 ps-3">
          <div class="attr-right">
            <!-- Start Atribute Navigation -->
            <div class="attr-nav">
              <ul>
                <li class="button">
                  <a routerLink="/contact">Book a Demo</a>
                </li>
              </ul>
            </div>
            <!-- End Atribute Navigation -->

          </div>
        </div>

      </div>
      <!-- Main Nav -->
      <!-- Overlay screen for menu -->
      <div class="overlay-screen"></div>
      <!-- End Overlay screen for menu -->
    </div>
  </nav>
  <!-- End Navigation -->
</header>
<!-- End Header -->
<router-outlet></router-outlet>
<!-- Start Footer
============================================= -->
<footer class="bg-dark footer-style-two text-light bg-cover" style="background-image: url(assets/img/shape/banner-8.jpg);">
  <div class="container">
    <div class="f-items relative pt-70 pb-120 pt-xs-0 pb-xs-50">
      <div class="row">
        <div class="col-lg-4 col-md-6 footer-item pr-50 pr-xs-15">
          <div class="f-item about">
            <img class="logo" src="assets/img/novarix.png" alt="Logo">
            <p>Crafting intelligent, scalable, and delightful software for startups and enterprises.</p>
            <!--<p>
              Nirman has been operating the construction market since 2016. Providing services in the line construction area, our main objective is to provide quality.
            </p>-->
            <ul class="footer-social">
              <li>
                <a href="#">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 footer-item">
          <div class="f-item link">
            <h4 class="widget-title">Our Products</h4>
            <ul>
              <li>
                <a href="https://norbix.novarix.tech" target="_blank">Norbix Enterprise</a>
              </li>
              <li>
                <a href="https://norbix.novarix.tech/products/novahrm" target="_blank">NovaHRM</a>
              </li>
              <li>
                <a href="https://norbix.novarix.tech/products/novafleet" target="_blank">NovaFLEET</a>
              </li>
              <li>
                <a href="https://norbix.novarix.tech/products/novaconnects" target="_blank">NovaConnects</a>
              </li>
              <li>
                <a href="https://compass.novarix.tech" target="_blank">Norbix Compass</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 footer-item">
          <div class="f-item link">
            <h4 class="widget-title">Company</h4>
            <ul>
              <li>
                <a routerLink="/about-us">About Us</a>
              </li>
              <li>
                <a routerLink="/services">Services</a>
              </li>
              <li>
                <a routerLink="/portfolio">Portfolio & Cases</a>
              </li>
              <li>
                <a routerLink="/organizational-chart">Org Chart</a>
              </li>
              <li>
                <a routerLink="/mentor">Mentors</a>
              </li>
              <li>
                <a routerLink="/contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 footer-item">
          <div class="f-item contact">
            <h4 class="widget-title">Get in touch</h4>
            <ul>
              <li>
                <i class="fas fa-map-marker-alt"></i>
                <p>
                  Registered Office: #5-8-670, Srinivasa Nagar, Tadigadapa, Vijayawada, Krishna (Dist), Andhra Pradesh, India. Pincode: - 521137
                </p>
              </li>
              <li>
                <i class="fas fa-phone-alt"></i>
                <p>
                  <a href="tel:+919281441225">+91 92814 41225</a>
                </p>
              </li>
              <li>
                <i class="fas fa-envelope"></i>
                <p>
                  novarixtech@gmail.com <br> info@novarix.tech
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Start Footer Bottom -->
  <div class="footer-bottom">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">

          <p>&copy; Copyright {{ currentYear }}. All Rights Reserved by <b>Novarix Technologies</b></p>
        </div>
        <div class="col-lg-6 text-end">
          <ul>
            <li>
              <a routerLink="/policies/terms-and-conditions"
                 routerLinkActive="active">Terms and Conditions</a>
            </li>
            <li>
              <a routerLink="/policies/privacy-policy"
                 routerLinkActive="active">Privacy</a>
            </li>
            <li>
              <a routerLink="/policies/refund-policy"
                 routerLinkActive="active">Refund</a>
            </li>
            <li>
              <a routerLink="/policies/cancellation-policy"
                 routerLinkActive="active">Cancellation</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- End Footer Bottom -->

</footer>
<!-- End Footer -->
